const loggedNavMenuItems = [
  { title: 'Dashboard', path: '/' },
  { title: 'My Account', path: '/accountStatus' },
  { title: 'Switch Profiles', path: '/' },
]

const mobileMenuContent = [
  {
    title: 'Docs',
    content: [
      {
        title: 'Online',
        path: 'https://developer.paypal.com/docs/online/',
      },
      {
        title: 'In-person',
        path: 'https://developer.paypal.com/docs/in-person/',
      },
      {
        title: 'Multiparty',
        path: 'https://developer.paypal.com/docs/multiparty/',
      },
      {
        title: '3rd-party',
        path: 'https://developer.paypal.com/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        path: 'https://developer.paypal.com/docs/payouts/',
      },
      {
        title: 'Disputes',
        path: 'https://developer.paypal.com/docs/disputes/',
      },
      {
        title: 'Reports',
        path: 'https://developer.paypal.com/docs/reports/',
      },
      {
        title: 'Identity',
        path: 'https://developer.paypal.com/docs/log-in-with-paypal/',
      },
      {
        title: 'Tracking',
        path: 'https://developer.paypal.com/docs/tracking/',
      },
      {
        title: 'Docs Archive',
        path: 'https://developer.paypal.com/docs/archive',
      },
    ],
  },
  {
    title: 'APIs & SDKs',
    content: [
      {
        title: 'REST APIs',
        path: 'https://developer.paypal.com/api/rest/',
      },
      {
        title: 'Server SDKs',
        path: 'https://developer.paypal.com/serversdk/http/getting-started/how-to-get-started/',
      },
      {
        title: 'Javascript SDK',
        path: 'https://developer.paypal.com/sdk/js/',
      },
      {
        title: 'Mobile SDKs',
        path: 'https://developer.paypal.com/sdk/mobile/',
      },
      {
        title: 'NVP/SOAP APIs',
        path: 'https://developer.paypal.com/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        path: 'https://developer.paypal.com/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        path: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    title: 'Tools',
    content: [
      {
        title: 'Upgrade hub',
        path: 'https://developer.paypal.com/upgrade/',
      },
      {
        title: 'Agent toolkit',
        path: 'https://www.paypal.ai/docs/tools/agent-toolkit-quickstart',
      },
      {
        title: 'MCP Server',
        path: 'https://www.paypal.ai/docs/tools/mcp-quickstart',
      },
      {
        title: 'VS Code extension',
        path: 'https://developer.paypal.com/tools/vscode/',
      },
      {
        title: 'Sandbox testing guide',
        path: 'https://developer.paypal.com/api/rest/sandbox/',
      },
      {
        title: 'Negative testing',
        path: 'https://developer.paypal.com/api/rest/sandbox/negative-testing/',
      },
      {
        title: 'Credit card generator',
        path: 'https://developer.paypal.com/api/rest/sandbox/card-testing/',
      },
      {
        title: 'Demo portal',
        path: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'Webhooks',
        path: 'https://developer.paypal.com/api/rest/webhooks/',
      },
      {
        title: 'Secure file transfer',
        path: 'https://developer.paypal.com/tools/dropzone/',
      },
      {
        title: 'API status',
        path: 'https://www.paypal-status.com/api/production',
      },
    ],
  },
  { title: 'Video Library', path: 'https://developer.paypal.com/video/home' },
  { title: 'Support', path: 'https://developer.paypal.com/docs/support' },
]

const mobileUserMenuContent = [
  { title: 'Dashboard', path: '/' },
  { title: 'My Account', path: '/accountStatus' },
  { title: 'Switch Profiles', path: '/' },
]

const sidenavNavigation = [
  {
    sectionTitle: 'Dashboard',
    items: [
      {
        title: 'Apps & Credentials',
        path: '/applications/ENVIRONMENT',
      },
      {
        title: 'Partner Setup',
        path: '/partner-setup',
      },
      {
        title: 'Home',
        path: '/',
      },
    ],
  },

  {
    sectionTitle: 'Testing Tools',
    items: [
      {
        title: 'Sandbox Accounts',
        path: '/accounts',
      },
      {
        title: 'Sandbox Notifications',
        path: '/notifications',
      },
      {
        title: 'Webhook Simulator',
        path: '/webhooksSimulator',
      },
    ],
  },
  {
    sectionTitle: 'Event Logs',
    items: [
      {
        title: 'API Calls',
        path: '/api-calls/ENVIRONMENT',
      },
      {
        title: 'Webhook Events',
        path: '/webhooks/ENVIRONMENT',
      },
      {
        title: 'Error Logs',
        path: '/errors/ENVIRONMENT',
      },
      {
        title: 'Transactions',
        path: '/transactions/ENVIRONMENT',
      },
    ],
  },
]
const mainButtonLinks = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Apps & Credentials',
    path: '/applications/ENVIRONMENT',
  },
  {
    title: 'Partner Setup',
    path: '/partner-setup',
  },
  {
    title: 'Testing Tools',
    menuItems: [
      {
        title: 'Sandbox Accounts',
        path: '/accounts',
        parentTitle: 'Testing Tools',
      },
      {
        title: 'Sandbox Notifications',
        path: '/notifications',
        parentTitle: 'Testing Tools',
      },
      {
        title: 'Webhook Simulator',
        path: '/webhooksSimulator',
        parentTitle: 'Testing Tools',
      },
    ],
  },
  {
    title: 'Event Logs',
    menuItems: [
      {
        title: 'API Calls',
        path: '/api-calls/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Webhook Events',
        path: '/webhooks/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Error Logs',
        path: '/errors/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
      {
        title: 'Transactions',
        path: '/transactions/ENVIRONMENT',
        parentTitle: 'Event Logs',
      },
    ],
  },
  {
    title: 'Upgrade',
    path: '/upgrade-your-apps',
  },
]

const mainNavigationBlue = [
  {
    title: 'Docs',
    menuItems: [
      {
        title: 'Online',
        path: 'https://developer.paypal.com/docs/online/',
      },
      {
        title: 'In-person',
        path: 'https://developer.paypal.com/docs/in-person/',
      },
      {
        title: 'Multiparty',
        path: 'https://developer.paypal.com/docs/multiparty/',
      },
      {
        title: '3rd-party',
        path: 'https://developer.paypal.com/docs/3rd-party/',
      },
      {
        title: 'Payouts',
        path: 'https://developer.paypal.com/docs/payouts/',
      },
      {
        title: 'Disputes',
        path: 'https://developer.paypal.com/docs/disputes/',
      },
      {
        title: 'Reports',
        path: 'https://developer.paypal.com/docs/reports/',
      },
      {
        title: 'Identity',
        path: 'https://developer.paypal.com/docs/log-in-with-paypal/',
      },
      {
        title: 'Tracking',
        path: 'https://developer.paypal.com/docs/tracking/',
      },
      {
        title: 'Docs archive',
        path: 'https://developer.paypal.com/docs/archive',
      },
    ],
  },
  {
    title: 'APIs & SDKs',
    menuItems: [
      {
        title: 'REST APIs',
        path: 'https://developer.paypal.com/api/rest/',
      },
      {
        title: 'Server SDKs',
        path: 'https://developer.paypal.com/serversdk/http/getting-started/how-to-get-started/',
      },
      {
        title: 'Javascript SDK',
        path: 'https://developer.paypal.com/sdk/js/',
      },
      {
        title: 'Mobile SDKs',
        path: 'https://developer.paypal.com/sdk/mobile/',
      },
      {
        title: 'NVP/SOAP APIs',
        path: 'https://developer.paypal.com/api/nvp-soap/',
      },
      {
        title: 'Donate SDK',
        path: 'https://developer.paypal.com/sdk/donate/',
      },
      {
        title: 'Braintree GraphQL API',
        path: 'https://graphql.braintreepayments.com/',
      },
    ],
  },
  {
    title: 'Tools',
    menuItems: [
      {
        title: 'Upgrade hub',
        path: 'https://developer.paypal.com/upgrade/',
      },
      {
        title: 'Agent toolkit',
        path: 'https://www.paypal.ai/docs/tools/agent-toolkit-quickstart',
      },
      {
        title: 'MCP Server',
        path: 'https://www.paypal.ai/docs/tools/mcp-quickstart',
      },
      {
        title: 'VS Code extension',
        path: 'https://developer.paypal.com/tools/vscode/',
      },
      {
        title: 'Sandbox testing guide',
        path: 'https://developer.paypal.com/api/rest/sandbox/',
      },
      {
        title: 'Negative testing',
        path: 'https://developer.paypal.com/api/rest/sandbox/negative-testing/',
      },
      {
        title: 'Credit card generator',
        path: 'https://developer.paypal.com/api/rest/sandbox/card-testing/',
      },
      {
        title: 'Demo portal',
        path: 'https://demo.paypal.com/us/demo/home',
      },
      {
        title: 'Webhooks',
        path: 'https://developer.paypal.com/api/rest/webhooks/',
      },
      {
        title: 'Secure file transfer',
        path: 'https://developer.paypal.com/tools/dropzone/',
      },
      {
        title: 'API status',
        path: 'https://www.paypal-status.com/api/production',
      },
    ],
  },
  {
    title: 'Video Library',
    path: 'https://developer.paypal.com/video/home',
  },
  {
    title: 'Help',
    path: 'https://www.paypal.com/smarthelp/home',
  },
  {
    title: 'Business Dashboard',
    path: 'https://www.paypal.com/mep/dashboard',
  },
]

export {
  loggedNavMenuItems,
  mobileMenuContent,
  mobileUserMenuContent,
  sidenavNavigation,
  mainButtonLinks,
  mainNavigationBlue,
}
